<template>
    <div class="step-template">
        <div :class="`text-wrapper step-${ this.appStep }`">
            <div class="left-wrapper">
                <h1>Vitadio ergänzt Ihre Behandlung</h1>
    
                <div class="text">
                    <p>Vitadio unterstützt dabei, <strong>Behandlungsziele</strong> nachhaltig zu erreichen.</p>
                    <p><strong>Die App motiviert täglich</strong>, indem sie verständlich Wissen vermittelt, <strong>erreichbare Ziele</strong> setzt und so langfristig Gewohnheiten verändert.</p>
                    <p><strong>Ohne Nebenwirkungen.</strong></p>
                </div>
                
                <v-button
                variant="primary"
                color="green"
                label="Sehen wir uns die App an"
                size="lg"
                @onClick="actualStep()" 
                />
            </div>
            
            <!-- <figure class="middle-wrapper">
                <picture>
                    <img src="/imgs/web/webdemo-doctors/app_step_2.webp" srcset="/imgs/web/webdemo-doctors/app_step_2.webp 1x, /imgs/web/webdemo-doctors/app_step_2@2x.webp 2x">
                </picture>
            </figure> -->

            <div class="right-wrapper text">
                <p><strong>Unterstützung zwischen den Arztbesuchen bzw. Schulungen</strong></p>
                <p>Vitadio knüpft vor und nach der Behandlung/Schulung an, motiviert zur Umsetzung des Erlernten und fördert das Erreichen des Behandlungsziels</p>
                <p><strong>Mehr Kontrolle</strong></p>
                <p>Berichte über die Fortschritte Ihrer Patientinnen und Patienten</p>
                <p><strong>Support für Ihre Patientinnen und Patienten</strong></p>
                <p>Persönliche Ansprechperson und Betreuung in der App vom ersten Schritt an und jeden Tag verfügbar</p>
            </div>
        </div>

        <figure class="middle-wrapper">
                <picture>
                    <img src="/imgs/web/webdemo-doctors/app_step_2.webp" srcset="/imgs/web/webdemo-doctors/app_step_2.webp 1x, /imgs/web/webdemo-doctors/app_step_2@2x.webp 2x">
                </picture>
            </figure>
    </div>
</template>

<script>
export default {

    props: {},
    data(){
        return {
            appStep: 2
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}

</script>

